import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Container from 'components/v2/container';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import { ACCESSORIAL_PDFS } from 'constants/pdf';
import AlertNotificator from 'components/site/notifications/AlertNotificator';
import CreditCardForm from 'components/modules/user/shipper/billing/CreditCardForm';
import BillingAddressForm from 'components/modules/user/billing-address-form';
import SessionStore from 'stores/SessionStore';
import ToastStore from 'stores/ToastStore';
import Sidebar from '../../../shipper/Sidebar';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';

class Details extends Component {

  onSaveBillingAddress = (data) => {
    ToastStore.removeLatestNotification();
    const shipperId = SessionStore.getUser()._id;
    const shipper = {
      _id: shipperId,
      billing_address: data,
    };
    CustomersActionCreators.validateAndUpdateBillingAddress(shipper);
  };

  render() {
    const shipperDetails = SessionStore.getUser();
    const { t } = this.props;
    return (
      <Container>
        <div className="lg:grid lg:grid-cols-12 lg:gap-6 mt-10">
          <div className="lg:col-span-3">
            <Sidebar activePage="billing" />
            <div className="billing-accessorial-pdf">
              <a
                href={ACCESSORIAL_PDFS.shipper}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 text-sm"
              >
                <span>{t('VIEW_ACCESSORIAL_DEF_CHARGES')}</span>
              </a>
            </div>
          </div>
          <div className="lg:col-span-6">
            <AuthorizationWrapper
              excludedRegions={[REGIONS.AP]}
            >
              <CreditCardForm className="mb-6" />
            </AuthorizationWrapper>
            <AlertNotificator />
            <AuthorizationWrapper
              excludedRegions={[REGIONS.AP]}
            >
              <BillingAddressForm
                className="mb-6"
                details={shipperDetails.billing_address}
                onSave={this.onSaveBillingAddress}
              />
            </AuthorizationWrapper>
          </div>
        </div>
      </Container>
    );
  }
}
export default withTranslation()(Details);
